module.exports = __webpack_public_path__ + "img/5coin.98b127ce.png";